import { DEFAULT_APP_COUNTRY } from "@/config/onboardingCountries";
import { formatRutDisplay, formatRutInput, isValidRut, normalizeRut, } from "@/utils/rut";
const SPECS = {
    CL: {
        country_code: "CL",
        label: "RUT",
        hint: "Opcional. Ingresa un RUT chileno válido.",
        placeholder: "12.345.678-5",
    },
    CO: {
        country_code: "CO",
        label: "Cédula",
        hint: "Opcional. Ingresa tu cédula de ciudadanía.",
        placeholder: "1234567890",
    },
    IT: {
        country_code: "IT",
        label: "Codice fiscale",
        hint: "Opcional. Ingresa tu código fiscal italiano.",
        placeholder: "RSSMRA80A01H501U",
    },
    GR: {
        country_code: "GR",
        label: "AFM",
        hint: "Opcional. Ingresa tu AFM (número fiscal).",
        placeholder: "123456789",
    },
};
export const resolveNationalIdCountry = (value) => {
    const normalized = String(value || "")
        .trim()
        .toUpperCase();
    if (normalized === "CO" || normalized === "IT" || normalized === "GR") {
        return normalized;
    }
    return DEFAULT_APP_COUNTRY;
};
export const getNationalIdSpec = (country) => SPECS[resolveNationalIdCountry(country)];
export const normalizeNationalId = (country, value) => {
    const code = resolveNationalIdCountry(country);
    const raw = String(value || "").trim();
    if (!raw)
        return "";
    if (code === "CL")
        return normalizeRut(raw);
    if (code === "CO")
        return raw.replace(/\D/g, "");
    if (code === "IT")
        return raw.toUpperCase().replace(/\s+/g, "");
    return raw.replace(/\D/g, "");
};
export const isValidNationalId = (country, value) => {
    const code = resolveNationalIdCountry(country);
    const normalized = normalizeNationalId(code, value);
    if (!normalized)
        return false;
    if (code === "CL")
        return isValidRut(normalized);
    if (code === "CO")
        return /^\d{5,10}$/.test(normalized);
    if (code === "IT") {
        return /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/.test(normalized);
    }
    return /^\d{9}$/.test(normalized);
};
export const formatNationalIdInput = (country, value) => {
    const code = resolveNationalIdCountry(country);
    if (code === "CL")
        return formatRutInput(value);
    if (code === "CO")
        return String(value || "").replace(/\D/g, "").slice(0, 10);
    if (code === "IT") {
        return String(value || "")
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, "")
            .slice(0, 16);
    }
    return String(value || "").replace(/\D/g, "").slice(0, 9);
};
export const formatNationalIdDisplay = (country, value) => {
    const code = resolveNationalIdCountry(country);
    if (code === "CL")
        return formatRutDisplay(value) || value;
    return normalizeNationalId(code, value) || value;
};
export const invalidNationalIdMessage = (country) => {
    const spec = getNationalIdSpec(country);
    if (spec.country_code === "CL") {
        return "El RUT ingresado no es válido. Revisa el número y el dígito verificador.";
    }
    return `El ${spec.label.toLowerCase()} ingresado no es válido.`;
};
/** CL e IT incluyen letras (DV K / codice fiscale); el resto puede ir numérico. */
export const nationalIdInputMode = (country) => {
    const code = resolveNationalIdCountry(country);
    return code === "CL" || code === "IT" ? "text" : "numeric";
};
